import { Link } from "react-router-dom";

const CTASection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title: "High-Net-Worth Advisory",
      desc:
        "For clients with complex financial structures and elevated goals, we offer dedicated high-net-worth advisory services. Our senior consultants bring deep expertise in bespoke wealth planning, legacy structuring, and multi-generational asset management — with the discretion and care you expect.",
      btn1: "Request a Private Consultation",
      btn2: "Explore AIA Products",
    },

    zh: {
      title: "高净值客户顾问服务",
      desc:
        "针对财务结构复杂且目标更高的客户，我们提供专属高净值顾问服务。我们的高级顾问在财富规划、传承架构及多代资产管理方面拥有丰富经验，并以高度的专业与保密为您服务。",
      btn1: "预约私人咨询",
      btn2: "了解 AIA 产品",
    },
  };

  return (
    <section className="mt-0 mb-10 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">

        <div className="bg-[#C09F7C] rounded-2xl md:rounded-3xl px-6 md:px-12 py-8 md:py-10 text-white text-left md:text-center shadow-lg">

          <div className="max-w-[60rem] mx-auto">

            <h2 className="text-2xl md:text-4xl font-medium mb-5 md:mb-6 leading-snug">
              {text[lang].title}
            </h2>

            <p className="text-white/90 leading-relaxed mb-6 text-sm md:text-base">
              {text[lang].desc}
            </p>

            {/* Buttons */}
            <div className="mt-6 md:mt-0 flex flex-col md:flex-row justify-center gap-4">

              <Link
                to="/contact"
                className="w-full md:w-auto inline-block bg-white text-[#154059] hover:bg-[#154059] hover:text-white transition-all duration-300 px-6 md:px-10 py-2.5 md:py-3 text-sm md:text-base font-medium rounded-full shadow-md hover:shadow-lg text-center"
              >
                {text[lang].btn1}
              </Link>

              <Link
                to="/about"
                className="w-full md:w-auto inline-block bg-white text-[#154059] hover:bg-[#154059] hover:text-white transition-all duration-300 px-6 md:px-10 py-2.5 md:py-3 text-sm md:text-base font-medium rounded-full shadow-md hover:shadow-lg text-center"
              >
                {text[lang].btn2}
              </Link>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default CTASection;